export const environment = {
  production: true,
  apiUrl: "https://blauwtand.com/api",
  contentApiUrl: "https://blauwtand.com/api",
  socketUrl: "https://blauwtand.com",
  googleAnalyticsId: "G-SZGV3WFRBT",
  googleTagManagerId: "GTM-5FHVRT45",
  siteUrl: "https://blauwtand.com",
  enableGtmDebug: false,
};
